import React from 'react';
import { cn } from '@/utils/style';
interface IProps {
  className?: string;
  children: React.ReactNode;
  style?: any;
}

const Card: React.FC<IProps> = ({ className, children, style = {} }) => {
  return (
    <div
      className={cn(
        'relative rounded-3xl border border-sky/50 bg-darker/40 p-6 sm:p-8 lg:rounded-[72px] lg:p-16',
        className
      )}
      style={style}
    >
      {children}
    </div>
  );
};

export default Card;
